export default __webpack_public_path__ + "static/media/lock.c47b5243.svg";